/**
 * Controller for the CMS Preference Colorpicker directive.
 */
class CMSPreferenceColorpickerController {
    /**
     * @param {Object} $scope - AngularJS scope.
     * @param {Object} $rootScope - AngularJS root scope.
     * @param {Object} $signals - Custom signals service.
     * @param {Object} $interval - AngularJS interval service.
     */
    constructor($scope, $rootScope, $signals, $interval) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$signals = $signals;
        this.$interval = $interval;

        this.$scope.data = this.$scope.prefData[this.$scope.theKey];
        this.$scope.randomId = angular.createUUID();
    }
}

/**
 * Registers the CMS Preference Colorpicker directive.
 * @param {Object} module - The AngularJS module to register the directive with.
 */
export default function registerCmsPreferenceColorpickerDirective(module) {
    module.directive('cmsPreferenceColorpicker', function($compile, $bridges, TaskDataService) {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                theKey: '=key',
                prefData: '=data',
                parentScope: '=scope',
                color: '=colorPicker'
            },
            templateUrl: "/views/ib/contentobjects/helpers/cms-preference-colorpicker.html",
            controller: CMSPreferenceColorpickerController,
            link: function(scope, element, attrs) {
                element.find('input').colorPicker({
                    pickerDefault: scope.parentScope.getScope().preferencesValues[scope.data.valueKey],
                    colors: ["000000", "3f3f3f", "7f7f7f", "bfbfbf", "ffffff",
                            "ff0000", "ff7f00", "ffff00", "7fff00",
                            "00ff00", "00ff7f", "00ffff", "007fff",
                            "0000ff", "7f00ff", "ff00ff", "ff007f",
                            "7f0000", "7f3f00", "7f7f00", "3f7f00",
                            "007f00", "007f3f", "007f7f", "003f7f",
                            "00007f", "3f007f", "7f007f", "7f003f",
                            "ffaaaa", "ffd4aa", "ffffaa", "d4ffaa", "transparent"],
                    showHexField: false,
                    onColorChange: function(id, newValue) {
                        scope.parentScope.getScope().preferencesValues[scope.data.valueKey] = (newValue === "transparent") ? 'none' : newValue;
                        scope.$apply();
                    }
                });

                scope.$watch('parentScope.getScope().preferencesValues[data.valueKey]', function(value) {
                    element.val(value);
                    element.change();
                });
            }
        };
    });
}